var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHelpingHand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510.5 510.5",
    height: 512,
    viewBox: "0 0 510.5 510.5",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb37e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.065,
    x2: 191.384,
    xlinkHref: "#lg1",
    y1: 283.884,
    y2: 312.959
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(.976 -.22 .22 .976 -57.152 44.021)",
    gradientUnits: "userSpaceOnUse",
    x1: 212.418,
    x2: 190.185,
    xlinkHref: "#lg1",
    y1: 311.003,
    y2: 333.235
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.414,
    x2: 201.94,
    xlinkHref: "#lg1",
    y1: 319.146,
    y2: 347.62
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.384,
    x2: 66.699,
    y1: 2.515,
    y2: 25.096
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00adfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f3ced"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(.27 .963 -.963 .27 479.393 -.372)",
    gradientUnits: "userSpaceOnUse",
    x1: 140.435,
    x2: 155.844,
    xlinkHref: "#lg1",
    y1: 283.954,
    y2: 468.137
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c6239",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(.27 .963 -.963 .27 479.393 -.372)",
    gradientUnits: "userSpaceOnUse",
    x1: 167.919,
    x2: 167.169,
    xlinkHref: "#lg2",
    y1: 437.205,
    y2: 371.948
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(.27 .963 -.963 .27 479.393 -.372)",
    gradientUnits: "userSpaceOnUse",
    x1: 296.496,
    x2: 266.402,
    y1: 351.991,
    y2: 286.595
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdaaa",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2054,
    stopColor: "#ffdfb5",
    stopOpacity: 0.205
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5703,
    stopColor: "#ffecd4",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(.27 .963 -.963 .27 479.393 -.372)",
    gradientUnits: "userSpaceOnUse",
    x1: -10.514,
    x2: -138.171,
    xlinkHref: "#lg2",
    y1: 423.59,
    y2: 376.15
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(.27 .963 -.963 .27 479.393 -.372)",
    gradientUnits: "userSpaceOnUse",
    x1: -76.43,
    x2: -11.308,
    y1: 404.56,
    y2: 443.474
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#91f27f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab172"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(.27 .963 -.963 .27 479.393 -.372)",
    gradientUnits: "userSpaceOnUse",
    x1: -39.343,
    x2: -146.189,
    y1: 433.231,
    y2: 351.762
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#91f27f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffed82"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(1 .011 -.011 1 5.611 -5.479)",
    gradientUnits: "userSpaceOnUse",
    x1: 460.622,
    x2: 447.487,
    y1: 525.866,
    y2: 489.142
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb4af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3177,
    stopColor: "#ffa2ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9516,
    stopColor: "#ff74ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff70ab"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd9a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbb27e"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(-1 0 0 -1 280.591 436.397)",
    gradientUnits: "userSpaceOnUse",
    x1: -32.843,
    x2: -38.525,
    xlinkHref: "#lg3",
    y1: 209.781,
    y2: 238.856
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(-.976 .22 -.22 -.976 337.744 392.376)",
    gradientUnits: "userSpaceOnUse",
    x1: 4.478,
    x2: -17.755,
    xlinkHref: "#lg3",
    y1: 188.101,
    y2: 210.333
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(-1 0 0 -1 280.591 436.397)",
    gradientUnits: "userSpaceOnUse",
    x1: 0.506,
    x2: -27.968,
    xlinkHref: "#lg3",
    y1: 245.043,
    y2: 273.517
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(.27 .963 -.963 .27 882.026 -413.324)",
    gradientUnits: "userSpaceOnUse",
    x1: 508.847,
    x2: 526.215,
    xlinkHref: "#lg3",
    y1: 660.589,
    y2: 807.167
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(.27 .963 -.963 .27 882.026 -413.324)",
    gradientUnits: "userSpaceOnUse",
    x1: 691.226,
    x2: 721.146,
    y1: 672.506,
    y2: 672.506
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb27e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(.27 .963 -.963 .27 1667.009 -156.788)",
    gradientUnits: "userSpaceOnUse",
    x1: 273.86,
    x2: 338.982,
    y1: 1348.467,
    y2: 1387.381
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b62cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833ac1"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(.27 .963 -.963 .27 1667.009 -156.788)",
    gradientUnits: "userSpaceOnUse",
    x1: 293.97,
    x2: 187.125,
    y1: 1364.194,
    y2: 1282.724
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b62cd",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff75c8"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(.27 .963 -.963 .27 882.026 -413.324)",
    gradientUnits: "userSpaceOnUse",
    x1: 540.134,
    x2: 538.05,
    y1: 714.184,
    y2: 652.358
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd9a9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m226.118 301.012c-2.208-2.939-5.349-4.852-8.876-5.037l-28.654-1.513c-10.534-.559-20.691-4.362-29.552-10.882-.685 17.258 9.534 32.396 23.667 34.924 3.595.643 7.228 1.08 10.888 1.303l24.598 1.499c4.455.272 8.467-2.274 10.887-6.323.188-.939.307-1.902.341-2.895.163-4.239-1.112-8.164-3.299-11.076z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m239.17 351.37-36.661-11.039c-5.455-1.644-10.803-3.543-16.031-5.685-20.551-8.423-31.307-31.124-24.954-52.406 11.363 11.439 25.52 19.971 41.245 24.595l42.777 12.568c5.266 1.546 9.418 5.104 11.844 9.594 2.403 4.449 3.118 9.823 1.566 15.053-.358 1.227-.834 2.384-1.407 3.486-4.899 4.152-11.739 5.833-18.379 3.834z",
    fill: "url(#SVGID_2_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m241.874 388.351-42.687-24.13c-6.351-3.592-12.498-7.473-18.424-11.624-23.299-16.32-30.333-47.712-16.394-72.509 10.97 17.495 26.249 32.148 44.59 42.36l49.897 27.767c6.143 3.417 10.326 9.033 12.09 15.327 1.748 6.236 1.125 13.152-2.289 19.247-.793 1.432-1.714 2.743-2.741 3.958-7.293 3.804-16.312 3.975-24.042-.396z",
    fill: "url(#SVGID_3_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m15.124 0h103.076c2 0 3.615 1.633 3.592 3.633l-.344 29.996h-113.609l.306-26.807c.044-3.811 3.168-6.865 6.979-6.822z",
    fill: "url(#SVGID_4_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m276.007 424.17c6.491-11.607 2.316-26.32-9.303-32.788l-47.299-26.328c-18.408-10.246-33.538-25.192-44.062-43.07 11.604-3.483 18.321-15.663 15.023-27.429l-3.989-14.233c-7.905-28.203-7.243-58.115 1.902-85.898 10.512-31.936 3.968-67.089-17.336-93.127l-52.854-64.601-24.856 6.967-73.009 20.464 7.105 13.363c24.608 46.283 44.158 95.093 58.309 145.576l16.399 58.506c15.317 54.645 51.619 100.994 100.919 128.851l40.482 22.874c11.526 6.514 26.107 2.427 32.569-9.127z",
    fill: "url(#SVGID_5_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m102.037 281.573c9.019 32.177 25.321 61.472 47.261 85.814l26.043-45.403c-.132.04-.48.146-.613.183-11.883 3.331-24.325-3.99-27.656-15.872l-4.306-15.364c-8.187-29.208-12.704-59.323-13.446-89.648l-.75-30.646-38.454 68.407z",
    fill: "url(#SVGID_6_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m243.432 433.298-40.471-22.878c-20.273-11.466-38.346-26.036-53.659-43.034l20.648-36.732c10.4 16.587 24.887 30.479 42.276 40.161l47.307 26.325c5.824 3.239 9.79 8.564 11.463 14.531 1.657 5.912 1.066 12.469-2.171 18.248-.752 1.358-1.625 2.601-2.598 3.753-6.915 3.608-15.466 3.77-22.795-.374z",
    fill: "url(#SVGID_7_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m125.25 45.451-7.163-8.755-24.856 6.967-73.007 20.464 7.105 13.364c13.503 25.397 25.473 51.559 35.874 78.337z",
    fill: "url(#SVGID_8_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m8.65 67.193-6.733-24.023c-1.565-5.583 1.692-11.377 7.275-12.942l106.445-29.836c5.583-1.565 11.377 1.692 12.942 7.275l6.734 24.023c1.565 5.583-1.692 11.377-7.275 12.942l-106.446 29.836c-5.583 1.565-11.377-1.692-12.942-7.275z",
    fill: "url(#SVGID_9_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m124.397 15.106c-1.565-5.583-7.359-8.84-12.942-7.275l-106.445 29.837c-1.277.358-2.425.946-3.429 1.693-.117 1.246-.022 2.532.336 3.809l6.733 24.023c1.565 5.583 7.359 8.84 12.942 7.275l106.446-29.837c1.277-.358 2.425-.946 3.428-1.693.117-1.246.022-2.532-.335-3.809z",
    fill: "url(#SVGID_10_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m498.925 510.499h-104.758c-1.559 0-2.817-1.273-2.799-2.831l.353-30.798h114.489l-.306 26.808c-.044 3.811-3.169 6.865-6.979 6.821z",
    fill: "url(#SVGID_11_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m284.382 209.488c2.208 2.939 5.349 4.852 8.876 5.037l28.654 1.513c10.534.559 20.691 4.362 29.552 10.882.685-17.258-9.534-32.396-23.667-34.924-3.595-.643-7.228-1.08-10.888-1.304l-24.598-1.499c-4.455-.272-8.467 2.274-10.887 6.323-.188.939-.307 1.901-.341 2.895-.163 4.24 1.112 8.165 3.299 11.077z",
    fill: "url(#SVGID_12_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m271.33 159.13 36.661 11.039c5.455 1.644 10.803 3.543 16.031 5.685 20.551 8.423 31.307 31.124 24.954 52.406-11.363-11.439-25.52-19.971-41.245-24.595l-42.777-12.568c-5.266-1.546-9.418-5.104-11.844-9.594-2.403-4.449-3.118-9.823-1.566-15.053.358-1.227.834-2.384 1.407-3.486 4.899-4.152 11.739-5.833 18.379-3.834z",
    fill: "url(#SVGID_13_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m268.626 122.148 42.687 24.13c6.351 3.592 12.497 7.473 18.424 11.624 23.299 16.32 30.333 47.712 16.394 72.509-10.97-17.495-26.25-32.148-44.591-42.36l-49.897-27.767c-6.143-3.417-10.326-9.033-12.09-15.327-1.748-6.236-1.125-13.152 2.289-19.247.793-1.432 1.714-2.743 2.741-3.958 7.294-3.803 16.313-3.974 24.043.396z",
    fill: "url(#SVGID_14_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m234.493 86.33c-6.491 11.607-2.316 26.32 9.303 32.788l47.299 26.328c18.408 10.246 33.538 25.192 44.062 43.07-11.604 3.483-18.322 15.663-15.023 27.429l3.989 14.233c7.905 28.203 7.243 58.115-1.902 85.898-10.512 31.936-3.968 67.089 17.336 93.127l52.854 64.601 24.856-6.967 73.007-20.464-7.105-13.363c-24.608-46.283-44.158-95.093-58.309-145.576l-16.399-58.506c-15.317-54.645-51.618-100.994-100.919-128.851l-40.482-22.874c-11.524-6.514-26.105-2.427-32.567 9.127z",
    fill: "url(#SVGID_15_)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m464.175 394.565-111.111 31.145 39.349 48.094 24.856-6.967 73.006-20.464-7.105-13.363c-6.715-12.631-13.04-25.456-18.995-38.445z",
    fill: "url(#SVGID_16_)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m381.921 502.833-6.734-24.023c-1.565-5.583 1.692-11.377 7.275-12.941l106.446-29.837c5.583-1.565 11.377 1.692 12.941 7.275l6.734 24.023c1.565 5.583-1.692 11.377-7.275 12.942l-106.446 29.837c-5.582 1.563-11.376-1.694-12.941-7.276z",
    fill: "url(#SVGID_17_)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m497.668 450.746c-1.565-5.583-7.359-8.84-12.942-7.275l-106.446 29.837c-1.277.358-2.425.946-3.428 1.693-.117 1.246-.022 2.532.336 3.809l6.734 24.023c1.565 5.583 7.359 8.84 12.941 7.275l106.446-29.837c1.277-.358 2.425-.946 3.429-1.693.117-1.246.022-2.532-.336-3.809z",
    fill: "url(#SVGID_18_)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m381.929 339.862-.75-30.646c-.742-30.325-5.259-60.439-13.446-89.648l-4.307-15.364c-3.331-11.883-15.77-19.193-27.653-15.862-.133.037-.616.173-.616.173-11.604 3.483-18.322 15.663-15.024 27.429l3.989 14.233c7.905 28.203 7.243 58.115-1.902 85.898-10.512 31.936-3.968 67.089 17.336 93.127l2.011 2.457z",
    fill: "url(#SVGID_19_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpingHand);
export default __webpack_public_path__ + "static/media/icon-helping-hand.0ed0c66c87fb61f33043a6a197bf2381.svg";
export { ForwardRef as ReactComponent };